import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Modal as ModalMUI, Fade, Divider, Backdrop, Button } from '@material-ui/core';
import { StarRate } from '@material-ui/icons';

const Modal = props => {

    const classes = useStyles();
    const { state, dispatch, visible, setVisible, numberFormat, services, affiliation, setAffiliation } = props;

    const handleClosedModal = () => {
        setVisible(false);
        dispatch({ type: 'clear' });
        setAffiliation('');
    }

    return (
        <ModalMUI
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={visible}
            onClose={handleClosedModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={visible}>
                <div className={classes.modalChildren}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: 30, marginRight: 30, marginBottom: 10, marginTop: 30 }}>
                        <strong style={{ fontFamily: 'Roboto', }}>DESCRIPCIÓN</strong>
                        <strong style={{ fontFamily: 'Roboto', }}>SUBTOTAL</strong>
                    </div>

                    <div style={{ overflow: 'auto' }}>
                        <div style={{ marginLeft: 30, marginRight: 30 }}>
                            {
                                state ? state.map((item, key) => (
                                    <div key={key.toString()}> 
                                        <div style={{ display: 'flex', justifyContent: 'space-between', borderBottomWidth: 1 }}>
                                            <p style={{ fontFamily: 'Roboto' }}>{ item.title }</p>
                                            <p style={{ fontFamily: 'Roboto' }}>{numberFormat(item.value)}</p>
                                        </div>
                                        <Divider />
                                    </div>
                                )) : 'Cargando...'
                            }
                        </div>

                        <div style={{ marginLeft: 30, marginRight: 30 }}>
                           {/* {
                               (!affiliation && services.cert) && (
                                   <>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', textTransform: 'lowercase' }}>
                                            <p style={{ fontFamily: 'Roboto' }}>{services.cert.name}</p>
                                            <p style={{ fontFamily: 'Roboto' }}>{numberFormat(parseInt(services.cert.value))}</p>
                                        </div>

                                        <Divider />
                                    </>
                               )
                           } */}

                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                {
                                    state.length > 2 ? (
                                        <>
                                            <p style={{ fontFamily: 'Roboto' }}>{ `${services.form.name } x ${state.length -1} und` }</p>
                                            <p style={{ fontFamily: 'Roboto' }}>{numberFormat((services.form.value * (state.length -1)))}</p>
                                        </>
                                    ) : (
                                        <>
                                            <p style={{ fontFamily: 'Roboto' }}>{services.form.name}</p>
                                            <p style={{ fontFamily: 'Roboto' }}>{numberFormat(services.form.value)}</p>
                                        </>
                                    )
                                }
                            </div>
                        </div>
                    </div>

                    <Divider />

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: 30 }}>
                        <Button variant='contained' style={{ background: '#4caf50', color: '#fff' }} onClick={() => window.open('https://sii.confecamaras.co/vista/plantilla/index.php?empresa=36&cod=00.03.002', '_blank')}>
                            Renovar
                        </Button>

                        <strong style={{ fontFamily: 'Roboto' }}>TOTAL: {state ? (() => {
                                const dataArray = state.reduce((acumulador, valor) => acumulador + valor.value, 0);
                                //const dataCert = !affiliation && services.cert ? parseInt(services.cert.value) : 0;
                                const dataForm = state.length > 2 ? services.form.value * (state.length -1) : services.form.value;
                                const dataAfi = !affiliation ? 0 : affiliation.value;
                                //const total = dataArray + dataCert + dataForm + dataAfi;
                                const total = dataArray + dataForm + dataAfi;
     
                                return numberFormat(total);
                            })(): 'Cargando...'}
                        </strong>
                    </div>
                    {
                        affiliation && (
                            <div style={{fontFamily: 'Roboto', fontSize: 13, fontWeight: '500',marginBottom: 5, marginRight: 10, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <StarRate htmlColor='#fbc02d' />
                                Costo de afiliación incluido
                            </div>
                        )
                    }
                </div>
            </Fade>
        </ModalMUI>
    )
}

const useStyles = makeStyles({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: 10,
    },
    modalChildren: {
        width: 550,
        minHeight: 200,
        maxHeight: 400,
        background: '#fff',
        outline: 0,
        borderRadius: 4,
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'space-evenly'
    }
});

export default Modal;